var script = {
    config: {},
    steps: [{
    	content: "There is no tour for the Summary Leakage Flow yet."
    }]
};

export default script;